var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{class:{
    'custom-icon-bg': _vm.value.endsWith(' bg'),
    'custom-icon-md': _vm.value.endsWith(' md'),
    'custom-icon-i': _vm.value.startsWith('icon-')
  },domProps:{"innerHTML":_vm._s(_vm.vHtml)}})}
var staticRenderFns = []

export { render, staticRenderFns }